"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.INPUT = exports.INPUT_STYLE_OBJECT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var DECORATOR_STYLES = function DECORATOR_STYLES(a) {
  var b = a.hasPrefix,
      c = a.hasSuffix,
      d = a.type,
      e = a.invalid,
      f = a.disabled;
  return _objectSpread(_objectSpread(_objectSpread({
    borderWidth: "1px ".concat(c ? 0 : "1px", " 1px ").concat(b ? 0 : "1px")
  }, b ? (0, _defineProperty2["default"])({
    paddingLeft: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, " ~ .input-container__decorator".concat(c ? ":first-of-type" : ""), _objectSpread(_objectSpread(_objectSpread({
    border: "1px solid ".concat(_vars.COLOURS.grey.mischka.russian),
    borderWidth: "1px 0 1px 1px",
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px"
  }, "SECONDARY" === d ? {
    borderColor: "transparent",
    background: _vars.COLOURS.grey.athens.parthenon
  } : {}), f ? {
    background: _vars.COLOURS.grey.athens.parthenon,
    color: _vars.COLOURS.grey.nevada,
    cursor: "default",
    pointerEvents: "none",
    borderColor: "transparent !important"
  } : {}), e ? {
    borderColor: "".concat(_vars.COLOURS.red.thunderBird, " !important")
  } : {})) : {}), c ? (0, _defineProperty2["default"])({
    paddingRight: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, " ~ .input-container__decorator".concat(b ? ":last-of-type" : ""), _objectSpread(_objectSpread(_objectSpread({
    border: "1px solid ".concat(_vars.COLOURS.grey.mischka.russian),
    borderWidth: "1px 1px 1px 0",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px"
  }, "SECONDARY" === d ? {
    borderColor: "transparent",
    background: _vars.COLOURS.grey.athens.parthenon
  } : {}), f ? {
    background: _vars.COLOURS.grey.athens.parthenon,
    color: _vars.COLOURS.grey.nevada,
    cursor: "default",
    pointerEvents: "none",
    borderColor: "transparent !important"
  } : {}), e ? {
    borderColor: "".concat(_vars.COLOURS.red.thunderBird, " !important")
  } : {})) : {}), {}, {
    ":hover:not(:focus) ~ .input-container__decorator": _objectSpread(_objectSpread(_objectSpread({
      borderColor: _vars.COLOURS.grey.regent
    }, "SECONDARY" === d ? {
      background: "".concat(_vars.COLOURS.grey.mischka.russian, " !important"),
      borderColor: "transparent"
    } : {}), f ? {
      background: _vars.COLOURS.grey.athens.parthenon,
      color: _vars.COLOURS.grey.nevada,
      cursor: "default",
      pointerEvents: "none",
      borderColor: "transparent !important"
    } : {}), e ? {
      borderColor: "".concat(_vars.COLOURS.red.thunderBird, " !important")
    } : {}),
    ":focus ~ .input-container__decorator": _objectSpread(_objectSpread(_objectSpread({
      borderColor: "".concat(_vars.COLOURS.grey.darkDenim, " !important")
    }, "SECONDARY" === d ? {
      background: "".concat(_vars.COLOURS.grey.mischka.russian, " !important"),
      borderColor: "transparent"
    } : {}), f ? {
      background: _vars.COLOURS.grey.athens.parthenon,
      color: _vars.COLOURS.grey.nevada,
      cursor: "default",
      pointerEvents: "none",
      borderColor: "transparent !important"
    } : {}), e ? {
      borderColor: "".concat(_vars.COLOURS.red.thunderBird, " !important")
    } : {})
  });
},
    CORE = {
  border: "1px solid ".concat(_vars.COLOURS.grey.mischka.russian),
  borderRadius: "4px",
  color: _vars.COLOURS.mono.black,
  caretColor: _vars.COLOURS.cyan.jungleGreen.monkey,
  fontSize: _vars.FONT_SIZES["default"],
  padding: "0 20px",
  width: "100%",
  lineHeight: "40px",
  boxSizing: "border-box",
  height: "40px",
  minHeight: "40px",
  background: _vars.COLOURS.mono.white,
  letterSpacing: "0.3px",
  order: 2,
  outline: "none !important",
  ":hover:not(:focus):not(:focus-within) ": {
    borderColor: _vars.COLOURS.grey.regent
  },
  ":focus": {
    borderColor: _vars.COLOURS.grey.darkDenim
  },
  ":focus-within": {
    borderColor: _vars.COLOURS.grey.darkDenim
  },
  "::placeholder": {
    textIndent: "3px",
    color: _vars.COLOURS.grey.nevada
  }
},
    SECONDARY = {
  borderColor: "transparent !important",
  background: _vars.COLOURS.grey.athens.parthenon,
  ":hover": {
    background: _vars.COLOURS.grey.mischka.russian,
    borderColor: "transparent"
  },
  ":focus": {
    background: _vars.COLOURS.grey.mischka.russian,
    borderColor: "transparent"
  }
},
    AUTO_GROW = {
  width: "unset",
  display: "block",
  cursor: "text",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:focus": {
    textOverflow: "unset"
  }
},
    DISABLED = {
  background: _vars.COLOURS.grey.athens.parthenon,
  color: _vars.COLOURS.grey.nevada,
  cursor: "default",
  pointerEvents: "none",
  borderColor: "transparent !important"
},
    INVALID = {
  borderColor: "".concat(_vars.COLOURS.red.thunderBird, " !important")
};

function getOptionalStyles(a) {
  var b = a["if"],
      c = a.styles;
  return b ? c : {};
}

var INPUT_STYLE_OBJECT = function INPUT_STYLE_OBJECT(a) {
  var b = a.disabled,
      c = a.valid,
      d = !(void 0 !== c) || c,
      e = a.hasPrefix,
      f = a.hasSuffix,
      g = a.type,
      h = void 0 === g ? "PRIMARY" : g,
      i = a.autoGrow;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, CORE), getOptionalStyles({
    if: e || f,
    styles: DECORATOR_STYLES({
      hasPrefix: e,
      hasSuffix: f,
      type: h,
      invalid: !d,
      disabled: b
    })
  })), getOptionalStyles({
    if: "SECONDARY" === h,
    styles: SECONDARY
  })), getOptionalStyles({
    if: i,
    styles: AUTO_GROW
  })), getOptionalStyles({
    if: b,
    styles: DISABLED
  })), getOptionalStyles({
    if: !d,
    styles: INVALID
  }));
};

exports.INPUT_STYLE_OBJECT = INPUT_STYLE_OBJECT;

var INPUT = function INPUT(a) {
  return (0, _cxs["default"])(INPUT_STYLE_OBJECT(a));
};

exports.INPUT = INPUT;